// extracted by mini-css-extract-plugin
export default {"spinnerMask":"PublishTab_spinnerMask__2-J+p"};